import { useState, useLayoutEffect } from '@wordpress/element';

const normalizeTaxEls = (t) => {
	return {
		name: t.name,
		link: t.link,
		value: t.count,
		parent: t.parent,
		id: t.term_id,
	};
};

/**
 *
 * @param {*} array
 * @param {*} start
 * @param {*} stop
 * @param {*} step
 * @param     howMany
 * @return
 */
function getArrayItemsRange(array, start, stop, howMany) {
	// Generate indexes
	const idxs = generateIndexesExponentially(start, stop, howMany);

	const result = idxs.map((idx) => array[idx - 1]);

	return result;
}

function generateIndexesExponentially(start, limit, howMany) {
	const step = (limit - 1 - start) / (howMany - 1);

	return Array.from({ length: howMany }, (value, index) => {
		return Math.round(1 + step * index);
	});
}

function useWindowSize() {
	const [size, setSize] = useState([0, 0]);
	useLayoutEffect(() => {
		function updateSize() {
			setSize([window.innerWidth, window.innerHeight]);
		}
		window.addEventListener('resize', updateSize);
		updateSize();
		return () => window.removeEventListener('resize', updateSize);
	}, []);
	return size;
}

function convertRemToPixels(rem) {
	return (
		rem *
		parseFloat(window.getComputedStyle(document.documentElement).fontSize)
	);
}

function getName(feat) {
	return feat.name || feat.properties?.NAME;
}

function buildTermsTree(flatTerms) {
	const flatTermsWithParentAndChildren = flatTerms.map((term) => {
		return {
			children: [],
			parent: null,
			...term,
		};
	});

	// All terms should have a `parent` because we're about to index them by it.
	if (flatTermsWithParentAndChildren.some(({ parent }) => parent === null)) {
		return flatTermsWithParentAndChildren;
	}

	const termsByParent = flatTermsWithParentAndChildren.reduce((acc, term) => {
		const { parent } = term;
		if (!acc[parent]) {
			acc[parent] = [];
		}
		acc[parent].push(term);
		return acc;
	}, {});

	const fillWithChildren = (terms) => {
		return terms.map((term) => {
			const children = termsByParent[term.id];
			return {
				...term,
				children:
					children && children.length
						? fillWithChildren(children)
						: [],
			};
		});
	};

	return fillWithChildren(termsByParent['0'] || []);
}

export {
	normalizeTaxEls,
	getArrayItemsRange,
	useWindowSize,
	convertRemToPixels,
	getName,
	buildTermsTree,
};
